jQuery(document).ready(function($){
    $('.parent-trigger .tgi-trigger').on('click',function(e){
        if($(window).width() <= 1023) {
            $(this).stop().toggleClass('open');
            $(this).parent().find('.tgi-content').stop().slideToggle();
        }
    });

    $('.customize-title-mob').on('click',function(e){
        if($(window).width() <= 1023) {
            $(this).stop().toggleClass('open');
            $('.sliding-holder').stop().slideToggle();
        }
    });
});